import TechWorks from "../../../../svg/TechWorks";
import "./ServerUnavailable.css";

export default function ServerUnavailable() {
  return (
    <div className="errorBody">
      <div className="errorMark">
        <TechWorks />
        <span className="errorText">
          Сервис временно недоступен. Вернемся к вам как можно скорее.
        </span>
        <button
          className="errorButton"
          onClick={() => window.location.reload()}
        >
          Повторить
        </button>
      </div>
    </div>
  );
}
